/**
 * Main application entry point.
 */

'use strict';

var app = require('mag-app');

require('./game/animframe_polyfill');

// everything is ready
app.once('load', function () {
    // load pages
    app.pages = {
        init: require('./pages/init'),
        main: require('./pages/main')
    };

    // show splash screen
    //app.route(app.pages.init);

    // show main page
    setTimeout(function () {
        app.ready();
        app.route(app.pages.main);
    }, 300);
});
